import { FilmFilterKey, FilterType, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { SingleFilterDisplayMode } from './display-mode';
export const singleFilterConfigValidator = Validator.object({
    filterType: Validator.oneOf(Object.values(FilterType)),
    filter: nonEmptyStringValidator,
    displayMode: nonEmptyStringValidator,
    isFilterModalAnchoredToTop: Validator.optional(Validator.boolean()),
    enableSearch: Validator.boolean(),
    showAllOption: Validator.boolean()
});
export const defaultSingleFilterConfig = {
    filterType: FilterType.Film,
    filter: FilmFilterKey.Genre,
    displayMode: SingleFilterDisplayMode.Auto,
    isFilterModalAnchoredToTop: false,
    enableSearch: true,
    showAllOption: true
};
export const exampleSingleFilterConfig = defaultSingleFilterConfig;
